import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {Trans} from 'react-i18next';
import AddRequest from '../../contactus/addrequest';

export default function ContactUsFormModal({showForm, setShowForm}) {
  return (
    <Modal
      dialogClassName="app-auth-contactus-form-modal"
      show={showForm}
      onHide={() => setShowForm(false)}
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>
          <Trans i18nKey="p.contactus.title">Contact Us</Trans>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AddRequest />
      </Modal.Body>
    </Modal>
  );
}
